
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import TtkList from './TtkList';
const BusRentalTTK = ({ data }) => {
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-1'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working since:</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <DirectionsBusIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Bus Category :</b>&nbsp;<TtkList data={data?.busVehicle} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <LocationCityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Serving Cities :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <DirectionsBusIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Type Of Bus :</b>&nbsp;<TtkList data={data?.busType} /></p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Price:</b>&nbsp;<span>{data?.price}</span></p>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BusRentalTTK